import React from 'react';
import { IPlayerName } from '../../../../../shared/types/player.type';

const PlayerNamesContext = React.createContext({ names: [] as IPlayerName[] });

export default PlayerNamesContext;
